export default __webpack_public_path__ + "static/media/png.aeeefdcb.svg";